export default __webpack_public_path__ + "static/media/tool_R4c_form.e209134e.pdf";